export default __webpack_public_path__ + "static/media/1.42471a5a.jpg";